import {
  headerSettings
} from '../components/header';
import {
  ticker
} from '../components/ticker';
import {
  popup
} from '../components/popup';
import {
  form
} from '../components/form';
import {
  toTop
} from '../components/toTop';

document.addEventListener("DOMContentLoaded", () => {
  headerSettings();
  ticker();
  popup();
  form();
  toTop();
});


// WEBPACK FOOTER //
// app/scripts/pages/home.js